module.exports = __webpack_public_path__ + "static/media/canari_ski.b9b2987d.png";